

    // 点击提交按钮
    function onclickImprove(improveBtn) {
        const fpPromise = FingerprintJS.load()
        fpPromise.then(fp => fp.get()).then((result)=>{ 
           submitImprove(improveBtn, result.visitorId)
        })
    }

    // 提交改进
    function submitImprove(improveBtn, fingerprint) {
        const textarea = document.querySelector('.textarea-improve')
        const commentText = textarea.value.trim()

        if (!commentText) {
            textarea.classList.add('textarea-improve--error')
            let errorTip = textarea.parentNode.querySelector('.improve-error-tip')
            if (!errorTip) {
            errorTip = document.createElement('div')
            errorTip.className = 'improve-error-tip'
            textarea.parentNode.appendChild(errorTip)
            }
            errorTip.textContent = 'Please enter your improvement suggestions...'
            textarea.focus()
            return
        }

        textarea.classList.remove('textarea-improve--error')
        const errorTip = textarea.parentNode.querySelector('.improve-error-tip')
        if (errorTip) errorTip.remove()

        const submitBtn = document.getElementById('btn-submit-improve')
        const originalBtnText = submitBtn.textContent
        submitBtn.disabled = true
        submitBtn.textContent = 'Submitting...'

        const btnCustomerId = improveBtn.dataset.customerId
        const btnShopId = improveBtn.dataset.shopId
        const btnProductId = improveBtn.dataset.productId
        const btnCollectionId = improveBtn.dataset.collectionId

        try {
            var ua = navigator.userAgent || ''
            var appType = /Android/i.test(ua) ? 'android' : /iPhone|iPad/i.test(ua) ? 'ios' : 'desktop'
            var language = navigator.language || ''
            if (Array.isArray(navigator.languages) && navigator.languages.length) {
            language = navigator.languages[0]
            }

            const data = {
                comment_text: commentText,
                referer: location.href,
                shop_id: btnShopId,
                collection_id: btnCollectionId,
                product_id: btnProductId,
                customer_id: btnCustomerId,
                app_type: appType,
                language: language,
                fingerprint: fingerprint
            }

            // 改进接口
            fetch('https://sysback.hiywy.com/shopify/createImprove', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'from-shopify': '12@#',
                'Content-Type': 'application/json'
            }
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`)
                }
                return response.text()
            })
            .then(state => {
                const result = JSON.parse(state)

                if (result.errorCode == 0) {
                    textarea.value = ''

                    let successTip = textarea.parentNode.querySelector('.improve-success-tip')
                    if (!successTip) {
                        successTip = document.createElement('div')
                        successTip.className = 'improve-success-tip'
                        textarea.parentNode.appendChild(successTip)
                    }
                    // 输出提交成功
                    successTip.textContent = 'Submitted successfully, thank you for your suggestion!'
                    setTimeout(() => {
                        successTip.remove()
                    }, 3000)

                    // 提交后刷新列表
                    improveList(improveBtn, fingerprint)
                    } else {
                        let errorTip = textarea.parentNode.querySelector('.improve-error-tip')
                        if (!errorTip) {
                            errorTip = document.createElement('div')
                            errorTip.className = 'improve-error-tip'
                            textarea.parentNode.appendChild(errorTip)
                        }
                    errorTip.textContent = result.errorMessage || 'Submission failed, please try again later.'
                }
            })
            .catch(err => {
                console.error('Improve error:', err)
                let errorTip = textarea.parentNode.querySelector('.improve-error-tip')
                if (!errorTip) {
                    errorTip = document.createElement('div')
                    errorTip.className = 'improve-error-tip'
                    textarea.parentNode.appendChild(errorTip)
                }
                errorTip.textContent = 'Network error, please try again later.'
            })
            .finally(() => {
                submitBtn.disabled = false
                submitBtn.textContent = originalBtnText
            })
        } catch (error) {
            console.error('error:', error)
            submitBtn.disabled = false
            submitBtn.textContent = originalBtnText
        }
    }

    // 改进记录
    function improveList(improveBtn, fingerprint) {
        console.log(improveBtn, fingerprint)
        var btnCustomerId = improveBtn.dataset.customerId;
        var btnShopId = improveBtn.dataset.shopId;
        var btnProductId = improveBtn.dataset.productId;
        var btnCollectionId = improveBtn.dataset.collectionId;
        try {
            const data = {
                shop_id: btnShopId,
                collection_id: btnCollectionId,
                product_id: btnProductId,
                customer_id: btnCustomerId,
                fingerprint: fingerprint
            };

            // 改进记录接口
            fetch('https://sysback.hiywy.com/shopify/improveList', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "from-shopify": "12@#",
                "Content-Type": "application/json"
            },
            }).then((response) => {
            return response.text();
            })
            .then((state) => {
            const result = JSON.parse(state);

            if(result.errorCode == 0) {
                const { total, page_size, page, list } = result.data
                if(total > 0) {
                const historyImproveMain = document.getElementById('history-improve')
                historyImproveMain.innerHTML = ''
                // 创建记录列表
                list.forEach(item => {
                  let itemDiv = document.createElement('div')
                  itemDiv.classList.add('history-improve-item')

                  // 名字 + 删除按钮
                  let topDiv = document.createElement('div')
                  topDiv.classList.add('history-improve-item-top')

                  // 名字
                  let nameDiv = document.createElement('div')
                  nameDiv.classList.add('history-improve-item-name')
                  nameDiv.innerHTML = item.customer_name

                  // 删除按钮
                  let delDiv = document.createElement('div')
                  delDiv.classList.add('history-improve-item-del')
                  delDiv.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/></svg>'
                  delDiv.addEventListener('click', () => {
                    deleteImprove(itemDiv, item)
                  })

                  topDiv.appendChild(nameDiv)
                  topDiv.appendChild(delDiv)

                  // 内容
                  let contentDiv = document.createElement('div')
                  contentDiv.classList.add('history-improve-item-content')
                  contentDiv.innerHTML = item.comment_text

                  itemDiv.appendChild(topDiv)
                  itemDiv.appendChild(contentDiv)
                  historyImproveMain.appendChild(itemDiv)
                })
              }
            }

            })
            .catch(() => {
                console.warn('improveList failed, status:', res.status);
            })
            .finally(() => {

            });
        } catch (error) {
            console.error('error:', error);
        } finally {

        }
    }

    // 删除改进建议
    function deleteImprove(itemDiv, item) {
      if (!confirm('Are you sure you want to delete this suggestion?')) {
        return;
      }

      fetch('https://sysback.hiywy.com/shopify/deleteImprove' , {
        method: 'POST',
        body: JSON.stringify({ 
          id: item.id,     
        }),
        headers: {
          "from-shopify": "12@#",
          "Content-Type": "application/json"
        }
      })
      .then(response => response.json())
      .then(result => {
        if (result.errorCode == 0) {
          itemDiv.remove();
        } else {
          alert(result.errorMessage || 'Delete failed');
        }
      })
      .catch(err => {
        console.error('Delete error:', err);
        alert('Network error, failed to delete.');
      });
    }